import { FormText } from "Components/Features/CheckPrice/Products/productInterfaces";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { getCollectionOfDittoComponents } from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { CabinContentsCoverage } from "Store/interfaces/products/coverage";
import { TextLanguage } from "Store/texts/interfaces";
import { getDeductibleOptions } from "Utils/priceUtils";
import { FormikProps } from "formik";
import React from "react";
import { ChooseDeductible } from "../../../FormComponentsHouseProducts/ChooseDeductible";
import { CoverageElements } from "../../../House/ProductPrice/FormComponents/CoverageElements";
import { CabinPriceFormValues } from "../cabinProductPriceInterfaces";

interface Props {
  formProps: FormikProps<CabinPriceFormValues>;
  coverages: CoveragePriceCalculation[];
  checkPriceText: FormText;
  lang: TextLanguage;
  isLoading: boolean;
}

export const CoveragesAndDeductible = ({
  formProps,
  coverages,
  checkPriceText,
  lang,
  isLoading,
}: Props): React.ReactElement => {
  const { cabincontents: coverageCardTextComponents } =
    getCollectionOfDittoComponents(TextComponentNameLevel1.COVERAGE_CARD);

  return (
    <>
      {coverages.length > 0 && (
        <ChooseDeductible
          fieldName="contentsDeductible"
          formProps={formProps}
          options={getDeductibleOptions(
            INSURANCE_NAME_VALUE.CABIN_CONTENTS,
            coverages,
          )}
          label={checkPriceText.insurance.deductible.label[lang]}
          hint={checkPriceText.insurance.deductible.hint[lang]}
        />
      )}
      {formProps.values.contentsCoverage &&
        formProps.values.contentsDeductible &&
        formProps.isValid && (
          <CoverageElements
            coverages={coverages}
            selectedCoverage={formProps.values.contentsCoverage}
            coverageStandards={Object.values(CabinContentsCoverage)}
            coverageFieldName="contentsCoverage"
            deductible={formProps.values.contentsDeductible}
            priceIsLoading={isLoading}
            title={checkPriceText.insurance.coverage.title[lang]}
            product={ProductBackendName.CABIN_CONTENTS}
            textComponents={coverageCardTextComponents}
          />
        )}
    </>
  );
};
